// import { UserLevels } from '@models/user-level';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EmptyComponent } from '@core/empty/empty.component';
import { CanDeactivateGuard } from '@guards/can-deactivate-guard.service';
import { UserLevel } from '@models/user-level';

export const dialogRoutes: Routes = [
  { path: '', component: EmptyComponent, outlet: 'settings-outlet' },

  {
    path: 'forecasts',
    loadChildren: () => import('../../components/settings/forecasts/forecasts.module').then(m => m.ForecastsModule),
    outlet: 'settings-outlet',
    canDeactivate: [CanDeactivateGuard]
  },

  {
    path: 'calibration-assumptions',
    loadChildren: () =>
      import('../../components/settings/calibration-assumptions/calibration-assumptions.module').then(m => m.CalibrationAssumptionsModule),
    outlet: 'settings-outlet',
    canDeactivate: [CanDeactivateGuard]
  },

  {
    path: 'product-setup',
    loadChildren: () => import('../../components/settings/product-setup/product-setup.module').then(m => m.ProductSetupModule),
    outlet: 'settings-outlet',
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'acquisition-setup',
    loadChildren: () => import('../../components/settings/acquisition-setup/acquisition-setup.module').then(m => m.AcquisitionSetupModule),
    outlet: 'settings-outlet',
    canDeactivate: [CanDeactivateGuard]
  },
  // Task 10560 - Global settings is disabled for 20.12 release. Would be reenabled with the followup release with the installer
  {
    path: 'global-settings',
    loadChildren: () => import('../../components/settings/global-settings/global-settings.module').then(m => m.GlobalSettingsModule),
    outlet: 'settings-outlet',
    canDeactivate: [CanDeactivateGuard],
    data: { minLevel: UserLevel.DepositsAdministrator }
  }
];

@NgModule({
  imports: [RouterModule.forChild(dialogRoutes)],
  exports: [RouterModule]
})
export class SettingsRoutingModule {}
